import { render } from "./RestrictionStatisticTab.vue?vue&type=template&id=21c54922&scoped=true"
import script from "./RestrictionStatisticTab.vue?vue&type=script&lang=js"
export * from "./RestrictionStatisticTab.vue?vue&type=script&lang=js"

import "./RestrictionStatisticTab.vue?vue&type=style&index=0&id=21c54922&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21c54922"]])

export default __exports__